export default "__VITE_ASSET__CSTamaA7__"